import { ReactElement } from 'react';

import { ArrowBackLine, Button, Flex } from '@revenuemarket/cds';
import { useIsMobile } from '@revenuemarket/utils';
import Image from 'next/image';
import { useRouter } from 'next/router';

import LightThemeLogo from '~assets/images/clobe_light_theme.svg';
import ResetPasswordSteps from '~components/Auth/ResetPassword/steps/ResetPasswordSteps';
import { css } from '~libs/emotion';

/**
 * 비인증 회원이 비밀번호를 재설정하는 페이지
 */
export default function ResetPasswordPage() {
  const isMobile = useIsMobile();
  const router = useRouter();
  return (
    <div
      className={css`
        width: 100vw;
        height: 100vh;
        padding: 40px;
        @media (max-width: 768px) {
          padding: 20px;
        }
      `}
    >
      {!isMobile && (
        <div
          style={{ position: 'relative' }}
          onClick={() => {
            window.location.href = 'https://clobe.ai/';
          }}
        >
          <Image
            src={LightThemeLogo}
            alt="logo"
            className={css`
              width: 120px;
              height: 24px;
              position: absolute;
              top: 0;
              left: 0;
              @media (max-width: 768px) {
                position: relative;
              }
            `}
          />
        </div>
      )}
      <Flex
        align="flex-start"
        justify="center"
        style={{
          height: '100%',
        }}
        className={css`
          @media (max-width: 768px) {
            width: 100%;
            justify-content: flex-start !important;
            margin-top: 40px;
            align-items: flex-start !important;
          }
        `}
      >
        <Flex
          direction="column"
          gap={40}
          className={css`
            @media (max-width: 768px) {
              width: 100%;
            }
          `}
        >
          <Button
            icon={<ArrowBackLine />}
            onClick={() => {
              router.back();
            }}
            buttonSize="xlarge"
          />
          <ResetPasswordSteps title="비밀번호 찾기" />
        </Flex>
      </Flex>
    </div>
  );
}

ResetPasswordPage.getLayout = (node: ReactElement) => node;
